import React, { useEffect } from "react";
import styled from "styled-components/macro";
import { isAndroid, isIOS, isMobileOnly } from "react-device-detect";

const SubscriptionSuccessWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;

  .h2 {
    padding: 20px;
  }
`;

const SubscriptionSuccess = () => {
  useEffect(() => {
    if (isMobileOnly && isIOS) {
      // redirect to App Store page for Sudowrite
      window.location.href = "https://apps.apple.com/app/sudowrite/id6740884542";
    } else if (isMobileOnly && isAndroid) {
      // redirect to Google Play store page for Sudowrite
      window.location.href = "https://play.google.com/store/apps/details?id=com.humanplusplus.sudowrite&pcampaignid=subscription_success";
    }
  }, []);

  return (
    <SubscriptionSuccessWrapper>
      <h2>You’re all set, check your email for a link to log in with your account</h2>
    </SubscriptionSuccessWrapper>
  );
};

export default SubscriptionSuccess;
